import React from 'react'
import NavLink from '../../components/Routes/NavLink'

import PropertyManagerDashboard from '../../components/Dashboards/PropertyManagerDashboard'
import CommercialPropertyManagerDashboard from '../../components/Dashboards/CommercialPropertyManagerDashboard'
import TenantWorkOrdersList from '../../components/WorkOrders/TenantWorkOrdersList'
import TenantPayNow from '../../components/Billing/TenantPayNow'
import AdminDashboard from '../../components/Admin/Dashboard/AdminDashboard'
import OwnerDashboard from '../../components/Dashboards/OwnerDashboard'
import VendorDashboard from '../../components/Dashboards/VendorDashboard'

import { user } from '../../core/controllers/user';
import { tenantBilling } from '../../core/controllers/TenantBilling';
import { rentersInsurance } from '../../core/controllers/RentersInsurance';
import { lease } from '../../core/controllers/Lease';
import { property } from '../../core/controllers/Property';
import { modal } from '../../core/utilities/modal'

export default class HomeTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.mobileTarget = window.matchMedia("(min-width: 1000px)") /* Retain the target so the event listener can be 
            unmounted */
        this.hideTasksListener = event => { // Define the event lister
            if (event.matches) { // Window has gone from desktop to mobile view
                this.setState({
                    mobileView: true,
                })
            } else { // mobile to desktop
                this.setState({
                    mobileView: false,
                })
            }
        }
        this.mobileTarget.addEventListener("change", this.hideTasksListener) /* Add an event listener for showing the
            carousel */
        this.state = {
            user_type_alias: '',
            pocontact: null,
            communityBoard: '',
            didCallCommunityBoard: false,
            view: '1',
            tenantBillingIsSetup: false,
            doesHaveLease: false,
            invoices: null,
            autoPay: 'OFF',
            contractInformation: null,
            hasInsurance: false,
            leaseHasProperty: false,
            mobileView: this.mobileTarget.matches,
            pays_with_card: false,
            is_international_card: false
        };
    }

    componentWillUnmount() {
        this.mobileTarget.removeEventListener("change", this.hideTasksListener)
    }

    componentDidMount() {
        if (this.props.notFound == true) {
            modal.showInfo("Page not found!", "danger", "top", "center");
        }

        var self = this;
        user.getUserDataWithCallback(function(response) {
            if (response.data.user_data.user_type_alias == 'tenant') {
                self.setState({
                    user_type_alias: response.data.user_data.user_type_alias,
                    view: response.data.user_data.view,
                })

                tenantBilling.getBillingInformation(function(billingInformation) {
                    var autoPay = 'OFF';
                    if (billingInformation.autoPay == true) {
                        autoPay = 'ON';
                    }
                    tenantBilling.getLatestInvoice(function(response) {
                        rentersInsurance.getInsurance(function(insurance) {
                            self.setState({
                                tenantBillingIsSetup: billingInformation.bank_account_last_four ? true : false,
                                doesHaveLease: billingInformation.contractInformation ? true : false,
                                contractInformation: billingInformation.contractInformation,
                                invoices: response.data[0],
                                invoices_count: response.count,
                                autoPay: autoPay,
                                hasInsurance: insurance.data ? true : false,
                                pays_with_card: billingInformation.pays_with_card,
                                is_international_card: billingInformation.card_international
                            });
                        });
                    })
                });

                lease.getTenantData(function(tenantData){
                    var leaseID = tenantData.data.contract_id;
                    if (leaseID == null) {
                        self.setState({
                            doesHaveLease: false
                        });
                    } else {
                        self.setState({
                            doesHaveLease: true
                        });
                        lease.setLeaseID(leaseID);
                        lease.getLease(function(lease) {
                            if(lease.data[0].property){
                                self.setState({
                                    leaseHasProperty: true
                                });
                            } else {
                                self.setState({
                                    leaseHasProperty: false
                                });
                            }
                        });
                    }
                });
            } else {
                self.setState({
                    user_type_alias: response.data.user_data.user_type_alias,
                    view: response.data.user_data.view
                });
            }
        });
    }

    reload() {
        var self = this;
        user.getUserDataWithCallback(function(userInfo) {
            if (userInfo.data.user_data.user_type_alias == 'tenant') {
                tenantBilling.getBillingInformation(function(billingInformation) {
                    var autoPay = 'OFF';
                    if (billingInformation.autoPay == true) {
                        autoPay = 'ON';
                    }

                    tenantBilling.getLatestInvoice(function(invoices) {
                        var doesHaveLease = false;
                        var leaseHasProperty = false;
                        lease.getTenantData(function(tenantData){
                            const leaseID = tenantData.data.contract_id;
                            if (leaseID == null) {
                                doesHaveLease = false;
                            } else {
                                doesHaveLease = true;
                                lease.setLeaseID(leaseID);
                                lease.getLease(function(lease) {
                                    if (lease.data[0].property){
                                        leaseHasProperty = true
                                    } else {
                                        leaseHasProperty = false
                                    }
                                    self.setState({
                                        user_type_alias: userInfo.data.user_data.user_type_alias,
                                        view: userInfo.data.user_data.view,
                                        tenantBillingIsSetup: billingInformation.can_setup,
                                        doesHaveLease: billingInformation.contractInformation ? true : false,
                                        contractInformation: billingInformation.contractInformation,
                                        invoices: invoices.data[0],
                                        invoices_count: invoices.count,
                                        autoPay: autoPay,
                                        doesHaveLease: doesHaveLease,
                                        leaseHasProperty: leaseHasProperty
                                    });
                                });
                            }
                        });
                    })
                });
            } else {
                self.setState({
                    user_type_alias: userInfo.data.user_data.user_type_alias,
                    view: userInfo.data.user_data.view
                });
            }
        });
    }

    getPoContact() {
        var self = this;
        user.getPoContactInformation(function(response) {
            self.setState({
                pocontact: response.data
            })
        });
    }

    getCommunityBoard() {
        var self = this;
        user.getCommunityBoard(function(response) {
            self.setState({
                communityBoard: response.data,
                didCallCommunityBoard: true
            })
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        const userType = this.state.user_type_alias;
        const view = this.state.view;
        const pocontact = this.state.pocontact;
        const communityBoard = this.state.communityBoard;
        const didCallCommunityBoard = this.state.didCallCommunityBoard;
        const tenantBillingIsSetup = this.state.tenantBillingIsSetup;
        var doesHaveLease = false;
        const contractInformation = this.state.contractInformation;
        const autoPay = this.state.autoPay;
        const invoices = this.state.invoices;
        const hasInsurance = this.state.hasInsurance;
        const leaseHasProperty = this.state.leaseHasProperty;
        const count = this.state.invoices_count;
        const resize = this.state.mobileView;
        const lastFour = this.state.bank_account_last_four


        if(userType === 'contractor' && pocontact == null) {
            this.getPoContact();
        }

        if(userType === 'tenant' && !didCallCommunityBoard) {
            this.getCommunityBoard();
        }

        if (userType === 'tenant') {
            doesHaveLease = this.state.doesHaveLease
        }

        return (
            <div>
                {(userType != 'admin' && userType != 'property-manager' && userType != 'super-admin' && userType != 'owner' && userType != 'vendor') && (
                    userType != 'contractor' && (
                        <div>
                            <div class={resize ? (`col-md-7`) : (`col-md-12`)}>
                                <div class="card">
                                    {userType != 'tenant' && (
                                        <div class="header">
                                            <h4 class="title">Dashboard</h4>
                                            <p class="category"></p>
                                        </div>
                                    )}
                                    {userType == 'tenant' & resize ? (
                                        <div class="content">
                                            <div class="row">
                                                <div class="header">
                                                    <h4 class="title" style={resize ? ({ fontSize: `clamp(1.64rem, 1.6vw, 3.2rem)` }) : ({ fontSize: `clamp(2.6rem, 2vw, 3.2rem)`, textAlign: `center` })}>Community Board</h4>
                                                    <p class="category" style={resize ? ({ fontSize: `clamp(.8rem, .87vw, 2rem)` }) : ({ fontSize: `clamp(1.2rem, 2.5vw, 2rem)`, textAlign: `center` })}>Find out what is going on in your community.</p>
                                                </div>
                                                <div class="col-md-12">
                                                    {communityBoard !== '' ? (
                                                        <textarea disabled rows="4" cols="80" class="form-control" placeholder="Latest Updates" value={communityBoard} />
                                                    ) : (
                                                        <p>No new updates.  Check here later.</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (``)}
                                </div>
                                {contractInformation == null || invoices != null && (
                                    <TenantPayNow
                                        count={count}
                                        invoices={invoices}
                                        contractInformation={contractInformation}
                                        autoPay={autoPay}
                                        paysWithCard={this.state.pays_with_card}
                                        isInternationalCard={this.state.is_international_card}
                                        billingSetup={tenantBillingIsSetup}
                                        reloadParent={this.reload.bind(this)}
                                        updatePaymentMade={this.reload.bind(this)}
                                        linked={tenantBillingIsSetup}
                                    />
                                )}
                            </div>
                            {userType == 'tenant' && (
                                <div class={resize ? (`col-md-5`) : (`col-md-12`)}>
                                    <div class="card">
                                        <div class="header">
                                            <h4 class="title" style={resize ? ({ fontSize: `clamp(1.64rem, 1.6vw, 3.2rem)` }) : ({ fontSize: `clamp(2rem, 1.4vw, 3.2rem)`, textAlign: `center` })}>Active Maintenance Requests</h4>
                                            <p class="category" style={resize ? ({ fontSize: `clamp(.8rem, .87vw, 2rem)` }) : ({ fontSize: `clamp(.8rem, 2.5vw, 2rem)`, textAlign: `center` })}>See a list of all active maintenance requests</p>
                                        </div>
                                        <div class="content">
                                            <div class="text-center">
                                                <TenantWorkOrdersList orderFilter={"All"} sortOptions={"AND (YEAR(created_at) = YEAR(CURRENT_DATE()) AND MONTH(created_at) = MONTH(CURRENT_DATE()) AND DAY(created_at) = DAY(CURRENT_DATE()) OR YEAR(created_at) = YEAR(CURRENT_DATE()) AND MONTH(created_at) = MONTH(CURRENT_DATE()) AND DAY(created_at) = DAY(CURRENT_DATE() - 1) ) LIMIt 5"} tableType={"dashboard"} />
                                            </div>
                                        </div>
                                    </div>
                                    {(doesHaveLease && leaseHasProperty) && (
                                        <div class="card">
                                            <div class="header">
                                                <h4 class="title" style={resize ? ({ fontSize: `clamp(1.64rem, 1.6vw, 3.2rem)` }) : ({ fontSize: `clamp(2.6rem, 2vw, 3.2rem)`, textAlign: `center` })}>Renters Insurance</h4>
                                                <p class="category" style={resize ? ({ fontSize: `clamp(.8rem, .87vw, 2rem)` }) : ({ fontSize: `clamp(.8rem, 2.5vw, 2rem)`, textAlign: `center` })}>Get a quote in minutes from our partners at Liberty Mutual</p>
                                            </div>
                                            <div class="content">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="text-center">
                                                            <NavLink to={"/request/renters"}>
                                                                <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off">
                                                                    {hasInsurance ? (
                                                                        <span>View Policy</span>
                                                                    ) : (
                                                                        <span>Request a Quote</span>
                                                                    )}
                                                                </button>
                                                            </NavLink>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {!resize &&
                                        <div class="card">
                                            <div class="header">
                                                <h4 class="title" style={resize ? ({ fontSize: `clamp(1.64rem, 1.6vw, 3.2rem)` }) : ({ fontSize: `clamp(2.6rem, 2vw, 3.2rem)`, textAlign: `center` })}>Community Board</h4>
                                                <p class="category" style={resize ? ({ fontSize: `clamp(.8rem, .87vw, 2rem)` }) : ({ fontSize: `clamp(1.2rem, 2.5vw, 2rem)`, textAlign: `center` })}>Find out what is going on in your community.</p>
                                            </div>
                                            <div class="col-md-12" style={{ paddingBottom: `10px` }}>
                                                {communityBoard !== '' ? (
                                                    <textarea disabled rows="4" cols="80" class="form-control" placeholder="Latest Updates" value={communityBoard} />
                                                ) : (
                                                    <p>No new updates.  Check here later.</p>
                                                )}
                                            </div>
                                        </div>}
                                </div>
                            )}
                        </div>
                    )
                )}
                { (userType == 'admin' || userType == 'property-manager') && view == '1' && (
                    <PropertyManagerDashboard />
                )}
                { (userType == 'admin' || userType == 'property-manager') && (view == '2' || view == '3') && (
                    <CommercialPropertyManagerDashboard />
                )}
                { userType == 'super-admin' && (
                    <AdminDashboard />
                )}
                { userType == 'owner' && (
                    <OwnerDashboard />
                )}
                { userType == 'vendor' && (
                    <VendorDashboard />
                )}
                { userType == 'contractor' && (
                <div class="col-md-4">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Primary Contact</h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <div class="row">
                                <div class="col-md-12">
                                    { pocontact !== null ? (
                                        <div>
                                            <p>
                                            Name: {pocontact.firstname} {pocontact.lastname}
                                            </p>
                                            <p>
                                            Phone: <a href={"tel:" + pocontact.phone}>{pocontact.phone}</a>
                                            </p>
                                            <p>
                                            Email: <a href={"mailto:" + pocontact.email}>{pocontact.email}</a>
                                            </p>
                                            <p>
                                            Company: {pocontact.company}
                                            </p>
                                        </div>
                                    ) : (
                                        <p>
                                            No Contact Information
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Home/Home.jsx